import type { ReactNode } from 'react'
import ClimateMetricCard from '../common/ClimateMetricCard'

type PortfolioSummaryMetricCardProps = {
  title: string
  helpText?: ReactNode
  loading?: boolean
  transitionKey: string
  children: ReactNode
  valueAlign?: 'flex-start' | 'center' | 'flex-end'
  minValueHeight?: number
}

const PortfolioSummaryMetricCard = ({
  title,
  helpText,
  loading = false,
  transitionKey,
  children,
  valueAlign = 'flex-start',
  minValueHeight = 24,
}: PortfolioSummaryMetricCardProps) => {
  return (
    <ClimateMetricCard
      title={title}
      helpText={helpText}
      loading={loading}
      transitionKey={transitionKey}
      variant="elevation"
      contentSx={{ height: '100%' }}
      motionMinHeight={minValueHeight}
      motionLayout="inline"
      motionJustifyContent={valueAlign}>
      {children}
    </ClimateMetricCard>
  )
}

export default PortfolioSummaryMetricCard
